import NotebookPen from "./SVG/notebook-pen.svg?react";

const NotebookPenIcon = () => {
  return <NotebookPen />;
};

export default NotebookPenIcon;
